// extracted by mini-css-extract-plugin
export default {"knocker":"doorKnocker_knocker__1VUG6","slideRight":"doorKnocker_slideRight__0OHRr","handle":"doorKnocker_handle__gFOgs","knock":"doorKnocker_knock__Wfhiv"};